import { type IMandatoryFieldConfiguration } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IMandatoryFieldConfigState } from './types';

export const GET_FROM_CLASS_NAME = 'getFromClassName';
export const GET_REFRESH_TIMESTAMP = 'getRefreshTimestamp';
export const GET_COMPLETE = 'getComplete';

export const getters: GetterTree<IMandatoryFieldConfigState, unknown> = {
    [GET_FROM_CLASS_NAME]: (_state: IMandatoryFieldConfigState) => {
        return (forClassName: string): IMandatoryFieldConfiguration | undefined => {
            const mandatoryFieldConfigId = _state.mandatoryFieldConfigurationByClassName.get(forClassName);
            return _state.dataObjectList.get(mandatoryFieldConfigId);
        };
    },
    [GET_REFRESH_TIMESTAMP]: (_state: IMandatoryFieldConfigState) => {
        return (): number | undefined => {
            return _state.timestamp;
        };
    },
    [GET_COMPLETE]: (_state: IMandatoryFieldConfigState) => {
        return (): boolean => {
            return _state.complete;
        };
    }
};
